import React, { useEffect } from "react"; // ✅ Added useEffect import
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import SmartifyLogin from "./Authenication/SmartifyLogin";
import SmartifySignup from "./Authenication/SmartifySignup";
import OtpVerification from "./Authenication/OtpVerification";
import ForgotPassword from "./Authenication/ForgotPassword";
import MarathiWordsPage from "./components/MarathiWordsPage";
import SlipSettings from "./components/sidebar/panels/SlipSettings";
import SirSearchPage from "./components/sir/SirSearchPage";
import SirUsersPage from "./components/sir/SirUsersPage";
import MainPage from "./MainPage";
import { CAMPAIGN_SEARCH_ENABLED, HOME_ROUTE } from "./appMode";

// remove the LanguageToggle import entirely
// import LanguageToggle from "./components/LanguageToggle";

function App() {

  // 🔥 DISABLE RIGHT-CLICK & INSPECT SHORTCUTS
  useEffect(() => {
    /**
     * Who is allowed to open devtools.
     *
     * Read at EVENT time, not at mount, so it takes effect immediately after
     * login without a reload.
     *
     * - SuperAdmin ("SuperAdmin" === "1") → always allowed, so problems in the
     *   field can actually be diagnosed.
     * - Nobody logged in → allowed. The login screen is exactly where
     *   connection failures have to be inspected, and there is no session to
     *   protect yet.
     * - Everyone else → blocked, as before.
     */
    const inspectAllowed = () => {
      try {
        return (
          localStorage.getItem("SuperAdmin") === "1" ||
          !localStorage.getItem("UserId")
        );
      } catch {
        return false; // localStorage unavailable (private mode) → keep the old behaviour
      }
    };

    // 1. Disable Right Click
    const handleContextMenu = (e) => {
      if (inspectAllowed()) return;
      e.preventDefault();
    };

    // 2. Disable Keyboard Shortcuts (F12, Ctrl+Shift+I, Ctrl+Shift+J, Ctrl+U)
    const handleKeyDown = (e) => {
      if (inspectAllowed()) return;
      if (
        e.key === "F12" ||
        (e.ctrlKey && e.shiftKey && e.key === "I") ||
        (e.ctrlKey && e.shiftKey && e.key === "J") ||
        (e.ctrlKey && e.shiftKey && e.key === "C") ||
        (e.ctrlKey && e.key === "U")
      ) {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    // Cleanup listeners
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <Router>
      {/* Language toggle removed from here — now inside the navbar */}
      <Routes>
        {/* While the campaign app is off, "/" is the public SIR search and
            staff log in at /login. Both routes always exist, so an old
            bookmark of either keeps working. */}
        <Route
          path="/"
          element={CAMPAIGN_SEARCH_ENABLED ? <SmartifyLogin /> : <SirSearchPage />}
        />
        <Route path="/login" element={<SmartifyLogin />} />
        <Route path="/signup" element={<SmartifySignup />} />
        <Route path="/verify-otp" element={<OtpVerification />} />
        <Route path="/slip-settings" element={<SlipSettings />} />
        <Route path="/ForgotPassword" element={<ForgotPassword />} />
        <Route path="/marathiwords" element={<MarathiWordsPage />} />
        <Route path="/WordManager" element={<MarathiWordsPage />} />
        {/* Campaign search — temporarily stopped, see src/appMode.js */}
        <Route
          path="/main"
          element={
            CAMPAIGN_SEARCH_ENABLED
              ? <MainPage />
              : <Navigate to={HOME_ROUTE} replace />
          }
        />
        {/* SIR 2026 — currently the app's landing page, see docs/sir-search.md */}
        <Route path="/sir" element={<SirSearchPage />} />
        {/* Super admin only — the page itself redirects anyone else, and
            GetSirUsers / AddSirCredits refuse them server-side. */}
        <Route path="/sir/users" element={<SirUsersPage />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );

}

export default App;